import { Typography } from "@circle-react-uikit/Typography";
import type { ComponentPropsWithoutRef } from "react";

interface LineItemProps {
  description: string;
  descriptionProps?: ComponentPropsWithoutRef<typeof Typography.BodySm>;
  value: string;
  valueProps?: ComponentPropsWithoutRef<typeof Typography.BodySm>;
}

export const LineItem = ({
  description,
  value,
  descriptionProps,
  valueProps,
}: LineItemProps) => (
  <div className="flex flex-row justify-between">
    <Typography.BodySm {...descriptionProps}>{description}</Typography.BodySm>
    <Typography.BodySm {...valueProps}>{value}</Typography.BodySm>
  </div>
);
